import React, { CSSProperties } from "react";
import SyncLoader from "react-spinners/SyncLoader";

const Loader = (props: any) => {
  const override: CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: props?.height,
  };

  return (
    <div style={props.style}>
      <SyncLoader
        color={props?.color}
        loading={props?.loading}
        cssOverride={override}
        size={props?.size}
      />
    </div>
  );
};

export default Loader;

//-----how to use-----
// import Loader from "../../utilities/Loader";
// -----------loader state------------
//   let [loading, setLoading] = React.useState(false);
//---calll as a component----
//   <Loader color="#5f67e0" loading={loading} size={20} height="auto" />;
